<template>
  <b-container class="container">
    <Headline title="Messages" />
    <Messages :inbox="fanInbox" v-if="fanInbox" />
  </b-container>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';

  .container {
    margin-top: 1em;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

</style>

<script>
import { mapGetters } from 'vuex'

import Headline from '@/components/widgets/Headline'
import Messages from '@/components/widgets/Messages'

export default {
  name: 'FanMessages',
  components: {
    Headline,
    Messages
  },
  computed: {
    ...mapGetters('profile', ['currentUser', 'fanInbox'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/fan/Messages.vue